// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38o9E","name":"styles_name__6Nptc","phone":"styles_phone__2yr4N"};